import React from "react";
import { useSelector } from "react-redux";
import { selectData } from "../pages/homeSlice";
import styled from "styled-components";
// Icons
import { Icon } from '@iconify/react';

const StyledSocialLinks = styled.div`
  a {
    margin: 0 1rem;
  }
`;

export default function SocialLinks() {
  const { blog, html_url } = useSelector(selectData);

  return (
    <StyledSocialLinks>
      <a
        href={html_url}
        aria-label="Check out my GitHub profile."
        className="link-icons"
      >
        <Icon icon="icomoon-free:github" />
      </a>
      <a
        href="https://twitter.com/h4wkst3r"
        aria-label="Check out my Twitter profile."
        className="link-icons"
      >
        <Icon icon="mdi:twitter" />
      </a>
      <a
        href="https://www.linkedin.com/in/brett-hawkins-ba843037"
        aria-label="Check out my LinkedIn profile."
        className="link-icons"
      >
        <Icon icon="mdi:linkedin" />
      </a>
      <a
        href="https://bsky.app/profile/h4wkst3r.bsky.social"
        aria-label="Check out my Bluesky profile."
        className="link-icons"
      >
        <Icon icon="simple-icons:bluesky" />
      </a>

    </StyledSocialLinks>
  );
}
